import { TTranslationKeys } from "$/i18n/i18n"
import type { TranslationObj } from "$/utils/lang"

enum ECoachInfoIntegrationMode {
    CoachingSessions = "coaching-sessions",
    OnboardingCoach = "onboarding-coach"
}

type TCoachInfoData = {
    bio: TranslationObj | null
    id: number
    firstName: string
    lastName: string
    photo: string | null
    certification: string | null
    country: string | null
    location: string | null
}

type TCoachInfoEntityProps =
    | {
          mode: ECoachInfoIntegrationMode.CoachingSessions
          titleConfig: [keyof TTranslationKeys] | [keyof TTranslationKeys, object]
          participantId: number
      }
    | {
          mode: ECoachInfoIntegrationMode.OnboardingCoach
          titleConfig: [keyof TTranslationKeys] | [keyof TTranslationKeys, object]
          coachData: TCoachInfoData
      }

export { ECoachInfoIntegrationMode }
export type { TCoachInfoEntityProps, TCoachInfoData }
